import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import styled, {css} from 'styled-components'

export const StyledMedicalRecordEmptyState = styled(Flexbox)(
    ({theme: {spacing}}) => css`
        padding: ${spacing * 6}px;
    `
)

export const StyledMedicalRecordEmptyStateCopyWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 488px;
    margin: 0 auto;
    text-align: center;
`

export const StyledMedicalRecordEmptyStateButtons = styled(Flexbox)(
    ({theme: {spacing}}) => css`
        margin-top: ${spacing * 4}px;
    `
)
